import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDF5bTdXp-SZwZT6l3qGuj6u4jka14mjRE",
  authDomain: "lottecastle-11df5.firebaseapp.com",
  projectId: "lottecastle-11df5",
  storageBucket: "lottecastle-11df5.firebasestorage.app",
  messagingSenderId: "955676923387",
  appId: "1:955676923387:web:9b0076c94fabcc0b55e75e",
  measurementId: "G-4DBLN3DL1N"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
